<template>
    <div class="container">
        <header>
            <h1>Pueblo County Tools</h1>
        </header>
        <main>
            <ul class="link-list">
                <li v-for="link in links" :key="link.title">
                    <a :href="link.url" target="_blank">{{ link.title }}</a>
                </li>
            </ul>
        </main>
    </div>
</template>

<script>
    export default {
        name: "App",
        data() {
            return {
                links: [
                    { title: "Inmate Lookup", url: "/inmates.html" },
                    { title: "Wanted Persons", url: "/wantedpersons.html" },
                    { title: "Maps", url: "/maps.html" },
                    { title: "DA Call Off List", url: "/district-attorneys-office/court-call-list" },
                    { title: "BOCC Meeting Minutes", url: "/documents.html" },
                ],
            };
        },
    };
</script>

<style>
    /* Styling */
    body {
        font-family: Arial, sans-serif;
        margin: 0;
        padding: 0;
        background-color: #f5f5f5;
        color: #333;
    }

    .container {
        max-width: 600px;
        margin: 50px auto;
        padding: 20px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    }

    header h1 {
        margin: 0;
        padding: 0 0 20px;
        font-size: 24px;
        border-bottom: 2px solid #ddd;
        text-align: center;
    }

    .link-list {
        list-style: none;
        padding: 0;
        margin: 20px 0 0;
    }

        .link-list li {
            margin: 10px 0;
        }

        .link-list a {
            color: #007BFF;
            text-decoration: none;
            font-size: 18px;
        }

            .link-list a:hover {
                text-decoration: underline;
            }
</style>
